import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lumiron-section-header',
  templateUrl: 'section-header.component.html',
  styleUrl: './section-header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class SectionHeaderComponent {}
